// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".desktop-icon-link{color:inherit;-webkit-text-decoration:none;text-decoration:none}.wish-list__wrap__bottom__link{color:#fff;-webkit-text-decoration:none;text-decoration:none}.wish-list__wrap__bottom__link__button{flex:1;margin-top:15px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
